import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../../../common/FormBase/index';
import Form from './Form';
import { FIELDS_GIFTCARD_BALANCE } from './validation/fields';
import { makeInitialState } from '../../../../../helpers/FormHelper';
import { schema } from './validation/schema';

const GiftCardBalance = ({ ...props }) => {
  const { mobile, motiveId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        mobile={mobile}
        title=""
        form={
          <Form
            state={state}
            onData={handleData}
            valid={valid}
            mobile={mobile}
            motiveId={motiveId}
          />
        }
        fields={FIELDS_GIFTCARD_BALANCE}
        pre
        data={data}
        formName="GiftCardBalance"
        schema={schema}
        makeInitialState={makeInitialState}
        onState={onState}
        onValid={handleValid}
      />
    </React.Fragment>
  );
};

GiftCardBalance.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
};

export default GiftCardBalance;
